import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-10 py-4">
        <Link to="/" className="flex items-center gap-2">
          <span className="font-heading text-2xl font-bold text-foreground-950 tracking-tight">
            Quick<span className="text-accent-500">Prosthetics</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          <a
            href="#features"
            className="text-foreground-700 hover:text-foreground-950 text-[15px] font-medium transition-colors whitespace-nowrap"
          >
            How It Works
          </a>
          <a
            href="#testimonials"
            className="text-foreground-700 hover:text-foreground-950 text-[15px] font-medium transition-colors whitespace-nowrap"
          >
            Stories
          </a>
          <Link
            to="/ai-artifacts"
            className="text-foreground-500 hover:text-accent-600 text-[14px] font-medium transition-colors whitespace-nowrap border border-background-300/60 rounded-full px-4 py-1.5 hover:border-accent-300"
          >
            Clinical Portal
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-900 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i
            className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
          ></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-6 py-5 flex flex-col gap-4">
          <a
            href="#features"
            className="text-foreground-700 hover:text-foreground-950 text-[15px] font-medium py-2"
            onClick={() => setMobileOpen(false)}
          >
            How It Works
          </a>
          <a
            href="#testimonials"
            className="text-foreground-700 hover:text-foreground-950 text-[15px] font-medium py-2"
            onClick={() => setMobileOpen(false)}
          >
            Stories
          </a>
          <Link
            to="/ai-artifacts"
            className="text-foreground-500 hover:text-accent-600 text-[14px] font-medium py-2"
            onClick={() => setMobileOpen(false)}
          >
            Clinical Portal
          </Link>
        </div>
      )}
    </nav>
  );
}
